import type { Action, ThunkAction } from "@reduxjs/toolkit";
import { combineSlices, configureStore } from "@reduxjs/toolkit";
import { selectedNumbersSlice as selectedNumbers } from './features/select-numbers-slice';
import { whatToPracticeSlice as whatToPractice } from './features/what-to-practice-slice';
import { numberOfQuestionsSlice as numberOfQuestions } from './features/number-of-questions-slice';
import { allowedTimeSlice as allowedTime } from './features/allowed-time-slice';
import { timeLeftSlice as timeLeft } from './features/time-left-slice';
import { allowedTimePerQuestionSlice as allowedTimePerQuestion } from './features/allowed-time-per-question-slice';
import { yourNameSlice as yourName } from './features/your-name-slice';



// `combineSlices` automatically combines the reducers using
// their `reducerPath`s, therefore we no longer need to call `combineReducers`.
const rootReducer = combineSlices(
  selectedNumbers
  , whatToPractice
  , numberOfQuestions
  , allowedTime
  , timeLeft
  , allowedTimePerQuestion
  , yourName
);
// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof rootReducer>;

// `makeStore` encapsulates the store configuration to allow
// creating unique store instances, which is particularly important for
// server-side rendering (SSR) scenarios. In SSR, separate store instances
// are needed for each request to prevent cross-request state pollution.
export const makeStore = () => {
  return configureStore({
    reducer: rootReducer,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware().concat();
    },
  });
};

// Infer the return type of `makeStore`
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore["dispatch"];
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>;
